import { RootPaths } from "@src/appV2/App/paths";

import { ACCOUNTS_PATH } from "../../redesign/Accounts/paths";

export const PAYROLL_PATH = "payroll";
export const ACCOUNTS_PAYROLL_FULL_PATH = `${RootPaths.APP_V2_HOME}/${ACCOUNTS_PATH}/${PAYROLL_PATH}`;
